import {useEffect,useState} from 'react';
import {Link} from 'react-router-dom';
import {fetchTaxpayerRegister} from '../services/api';
import {receiptState} from '../services/receiptPresentation';

export default function ReceiptNotifications() {
 const [rows,setRows]=useState<any[]|null>(null),[error,setError]=useState(''),[page,setPage]=useState(1),[total,setTotal]=useState(0),[revision,setRevision]=useState(0);
 useEffect(()=>{
  const refresh=()=>setRevision(v=>v+1);
  const timer=window.setInterval(refresh,30000);
  window.addEventListener('focus',refresh);window.addEventListener('fpt-workflow-changed',refresh);
  return()=>{clearInterval(timer);window.removeEventListener('focus',refresh);window.removeEventListener('fpt-workflow-changed',refresh)};
 },[]);
 useEffect(()=>{
  let active=true;setRows(null);setError('');
  fetchTaxpayerRegister('receipts',page).then(result=>{
   if(!Array.isArray(result?.items)||!Number.isInteger(result.total))throw new Error('Notifications de quittance indisponibles');
   if(active){setRows(result.items.filter((r:any)=>receiptState(r)==='issued'));setTotal(result.total)}
  }).catch(e=>{if(active)setError(e.message)});
  return()=>{active=false};
 },[page,revision]);
 return <section className="card" aria-label="Notifications de quittance"><h3>Quittances disponibles</h3><p>Les nouvelles quittances apparaissent automatiquement après apurement par l’ONT.</p>
  {error?<p role="alert">{error}</p>:rows===null?<p role="status">Chargement des quittances…</p>:rows.length?rows.map(r=><article key={r.id}><h4>Votre quittance {r.reference} est disponible</h4><p>{r.establishment} · {r.period}</p><Link className="btn" to={`/assistant?${new URLSearchParams({declaration_id:r.declaration_id,native:'1',step:'receipt',receipt_id:r.id})}`}>Consulter la quittance</Link></article>):<p>Aucune nouvelle quittance apurée sur cette page.</p>}
  <div className="actions"><button className="btn" disabled={page===1} onClick={()=>setPage(v=>v-1)}>Précédent</button><button className="btn" onClick={()=>setRevision(v=>v+1)}>Actualiser les quittances</button><button className="btn" disabled={page*25>=total} onClick={()=>setPage(v=>v+1)}>Suivant</button></div>
 </section>;
}
